<template lang="pug">
    .flex
        .w-5.h-5.border.flex.items-center.justify-center.cursor-pointer.rounded-md.bg-white.checkbox-shadow(@click="onCheck" style="minWidth: 20px; minHeight: 20px;")
            template(v-if="isChecked")
                img.block.w-3.h-3(:src="ICONS.checkmark")
        template(v-if="$slots.default")
            slot
</template>

<script>
//Configs
import { ICONS } from '../../../configs/icons';

export default {
    name: "checkbox",
    props: {
        checked: {
            type: Boolean,
            deafult: false,
        },
    },
    data() {
        return {
            isChecked: false,
        }
    },
    computed: {
        ICONS() {
            return ICONS
        },
    },
    methods: {
        onCheck() {
            this.isChecked = !this.isChecked
            this.$emit('value', this.isChecked)
        },
    },
    watch: {
        checked: {
            handler(val) {
                this.isChecked = val
            },
            immediate: true,
        }
    }
}
</script>